import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class ToolbarItem extends Component {
    static displayName = 'ToolbarItem';

    static propTypes = {
        disabled: PropTypes.bool,
        /** ARIA label attribute */
        ariaLabel: PropTypes.string,
        /** React children of this component */
        children: PropTypes.node,
        /** Any extra CSS class name(s) added to the root element */
        className: PropTypes.string,
        /** Custom spark icon class name */
        iconClass: PropTypes.string,
        /** Label identifying this component (Used as text or "title" attribute if iconClass is specified) */
        label: PropTypes.string,
        /** Custom click handler */
        onClick: PropTypes.func,
        /** ARIA role attribute */
        role: PropTypes.string,
        /** If true, "spark-toolbar__item--content__container" CSS class is skipped
         * (to remove extra padding when a menu is a child of this component) */
        skipContentContainer: PropTypes.bool,
        /** Custom tabindex attribute */
        tabIndex: PropTypes.string
    };

    static defaultProps = {
        disabled: false,
        ariaLabel: '',
        className: '',
        iconClass: '',
        label: '',
        role: 'menubaritem',
        skipContentContainer: false,
        tabIndex: '-1'
    };

    render() {
        const {
            disabled,
            ariaLabel,
            children,
            className,
            iconClass,
            label,
            onClick,
            role,
            tabIndex,
            skipContentContainer
        } = this.props;

        const rootElProps = {
            className: `spark-toolbar__item ${className} ${disabled ? 'disabled' : ''}`,
            label,
            onClick,
            'aria-label': ariaLabel || label,
            role,
            tabIndex: `${typeof tabIndex === 'number' && tabIndex < 0 ? '-1' : tabIndex}`
        };
        return (
            <div>
                <div {...rootElProps}>
                    {children && (
                        <div
                            className={`spark-toolbar__item--content ${
                                skipContentContainer ? '' : 'spark-toolbar__item--content__container'
                            }`}
                        >
                            {children}
                        </div>
                    )}
                    {iconClass ? (
                        <div className={`${iconClass} spark-toolbar__item-helper`} title={label} />
                    ) : (
                        <div className="spark-toolbar__item-helper" />
                    )}
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/ui/sabre-spark-react-ex/toolbar/toolbar-item.js